import ClientVendorSettings from './ClientVendorSettings'

function VendorSettings() {
    return <ClientVendorSettings open />
}

export default VendorSettings
